module.exports = __webpack_public_path__ + "static/media/p6.de68fb1e.jpeg";